module.exports = __webpack_public_path__ + "static/media/PlayfairDisplay-Regular.2dd8f19b.woff2";